import { LegacyOrganizationEntityListingPayload } from "./Admin";

export type BuzzerAlertListingPayload =
  LegacyOrganizationEntityListingPayload & {
    // add fields here
  };

export enum BuzzerAlertStatuses {
  PENDING = 1,
  INPROGRESS = 2,
  RESOLVED = 3,
}

export type BuzzerAlertUpdatePayload = {
  buzzerAlertId: number;
  status: BuzzerAlertStatuses;
};

export type NotificationListingPayload = {
  notify_type?: number;
  rule_id?: string;
  is_read?: 0 | 1;
  start_time?: string;
  end_time?: string;
  page: number;
  page_size: number;
};

export type NotificationItem = {
  id: number;
  created_at: string;
  updated_at: string;
  account_id: string;
  user_id: string;
  notify_type: number;
  title: string;
  message: string;
  data: any;
  is_read: boolean;
  device_id: string;
  rule_id: string;
  statuscode: number;
  timestamp: number;
};

// the NotificationSummaryPayload is added just for request purpose identification
// this is not actually needed by the backend API
export type NotificationSummaryPayload =
  | {
      tokenCheck: boolean;
    }
  | {
      polling: boolean;
    };

export type NotificationSummary = {
  total_notifications: number;
  total_alerts: number;
  is_buzzer_alert: boolean;
};

export type BuzzerAlertEventInfo = {
  accountid: string;
  address: string;
  deviceid: string;
  heading: number;
  latitude: number;
  longitude: number;
  recordid: number;
  statuscode: number;
  timestamp: number;
};

export type BuzzerAlert = {
  account_id: string;
  created_at: string;
  device_description: string;
  device_id: string;
  displayname: string;
  drivername: string;
  event_info: BuzzerAlertEventInfo | null;
  id: number;
  // lastnotifycode: number;
  // lastnotifyrule: string;
  // lastnotifytime: number;
  rule_description: string;
  rule_id: string;
  status: number;
  status_description: string;
  statuscode: number;
  timestamp: number;
  updated_at: string;
};

export type BuzzerAlertWithUUID = BuzzerAlert & {
  uuid: string;
};
